// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg width=%2760%27 height=%2760%27 viewBox=%270 0 60 60%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cg fill=%27none%27 fill-rule=%27evenodd%27%3E%3Cg fill=%27%23ffffff%27 fill-opacity=%270.05%27%3E%3Ccircle cx=%2730%27 cy=%2730%27 r=%274%27/%3E%3C/g%3E%3C/g%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Features Component Styles */
.hover-lift {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.hover-lift:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1) !important;
}

/* Ensure cards have proper stacking */
.card {
  position: relative;
  z-index: 1;
}

.card-img-top {
  position: relative;
  z-index: 2;
  transition: transform 0.3s ease;
  display: block;
  width: 100%;
  height: 280px;
  object-fit: cover;
}

.card .position-absolute {
  z-index: 1;
}

.card .card-body {
  position: relative;
  z-index: 3;
}

.bg-gradient-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.bg-gradient-success {
  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
}

.bg-gradient-info {
  background: linear-gradient(135deg, #667eea 0%, #f093fb 100%);
}

.hover-lift:hover .card-img-top {
  transform: scale(1.05);
}

/* Icon styling */
.rounded-circle {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.hover-lift:hover .rounded-circle {
  transform: scale(1.1);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
}

/* Button hover effects */
.btn {
  transition: all 0.3s ease;
}

.btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

/* Badge styling */
.badge {
  font-weight: 500;
  font-size: 0.9rem;
}

/* Section background with subtle pattern */
#features {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  position: relative;
}

#features::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  opacity: 0.1;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Landingpage/Features.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;EACE,qDAAqD;AACvD;;AAEA;EACE,4BAA4B;EAC5B,qDAAqD;AACvD;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,+BAA+B;EAC/B,cAAc;EACd,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,qDAAqD;AACvD;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,2CAA2C;AAC3C;EACE,6DAA6D;EAC7D,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yDAAmR;EACnR,YAAY;AACd","sourcesContent":["/* Features Component Styles */\n.hover-lift {\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.hover-lift:hover {\n  transform: translateY(-10px);\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1) !important;\n}\n\n/* Ensure cards have proper stacking */\n.card {\n  position: relative;\n  z-index: 1;\n}\n\n.card-img-top {\n  position: relative;\n  z-index: 2;\n  transition: transform 0.3s ease;\n  display: block;\n  width: 100%;\n  height: 280px;\n  object-fit: cover;\n}\n\n.card .position-absolute {\n  z-index: 1;\n}\n\n.card .card-body {\n  position: relative;\n  z-index: 3;\n}\n\n.bg-gradient-primary {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n}\n\n.bg-gradient-success {\n  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);\n}\n\n.bg-gradient-info {\n  background: linear-gradient(135deg, #667eea 0%, #f093fb 100%);\n}\n\n.hover-lift:hover .card-img-top {\n  transform: scale(1.05);\n}\n\n/* Icon styling */\n.rounded-circle {\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.hover-lift:hover .rounded-circle {\n  transform: scale(1.1);\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);\n}\n\n/* Button hover effects */\n.btn {\n  transition: all 0.3s ease;\n}\n\n.btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);\n}\n\n/* Badge styling */\n.badge {\n  font-weight: 500;\n  font-size: 0.9rem;\n}\n\n/* Section background with subtle pattern */\n#features {\n  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n  position: relative;\n}\n\n#features::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-image: url(\"data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Ccircle cx='30' cy='30' r='4'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\");\n  opacity: 0.1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
